import { computed } from 'vue'
import { useQuery } from '@tanstack/vue-query'

import { useCmsContentSearch } from '@/composables/useCmsContentSearch'
import { createQueryKey, mapVideo } from '@/utils'
import IbexaContentTypeIdentifier from '@/enums/IbexaContentTypeIdentifier'


export const useVideo = (contentId: number) => {
  const { search } = useCmsContentSearch()
  const videoSearchQuery = {
    ['contentTypes[]']: IbexaContentTypeIdentifier.vgsVideo,
    ['contentId[]']: [contentId.toString()],
    limit: '1',
  }

  const { data } = useQuery({
    queryKey: createQueryKey('vgsVideo', contentId),
    queryFn: () => search(videoSearchQuery),
  })

  const video = computed(() => {
    if (!data.value?.[0]) return

    return mapVideo(data.value[0])
  })

  return {
    video
  }
}

export default useVideo